import UseTarifsMainColor from "../../../hooks/UseTarifsMainColor";
import UseTarifsSecondColor from "../../../hooks/UseTarifsSecondColor";
import UseSelectedTarifsID from "../../../hooks/UseSelectedTarifsID";
import UseTarifRibbonColor from "../../../hooks/UseTarifsRibbonColor";

import "./tarifsDetailsText.css";

import TarifsDefault from "./tarifsDetailsTexts/tarifsDefault";
import TarifsDiag from "./tarifsDetailsTexts/tarifsDiag";
import TarifsComposant from "./tarifsDetailsTexts/tarifsComposant";
import TarifsVirus from "./tarifsDetailsTexts/tarifsVirus";
import TarifsDust from "./tarifsDetailsTexts/tarifsDust";
import TarifsSpeed from "./tarifsDetailsTexts/tarifsSpeed";
import TarifsOS from "./tarifsDetailsTexts/tarifsOS";
import TarifsRecondo from "./tarifsDetailsTexts/tarifsRecondo";
import TarifsShopping from "./tarifsDetailsTexts/tarifsShopping";
import TarifsMontage from "./tarifsDetailsTexts/tarifsMontage";
import TarifsContract from "./tarifsDetailsTexts/tarifsContract";
import TarifsSoftDev from "./tarifsDetailsTexts/tarifsSoftDev";
import TarifsWebDev from "./tarifsDetailsTexts/tarifsWebDev";

import { motion } from "framer-motion";

function TarifsDetailsText() {
  const selectedTarifsID = UseSelectedTarifsID((state) => state.value);

  var selectedText = <div></div>;

  switch (selectedTarifsID) {
    case 0:
      selectedText = <TarifsDiag />;
      break;
    case 1:
      selectedText = <TarifsComposant />;
      break;
    case 2:
      selectedText = <TarifsVirus />;
      break;
    case 3:
      break;
    case 4:
      selectedText = <TarifsDust />;
      break;
    case 5:
      selectedText = <TarifsSpeed />;
      break;
    case 6:
      selectedText = <TarifsOS />;
      break;
    case 7:
      selectedText = <TarifsRecondo />;
      break;
    case 8:
      selectedText = <TarifsShopping />;
      break;
    case 9:
      selectedText = <TarifsMontage />;
      break;
    case 10:
      selectedText = <TarifsContract />;
      break;
    case 11:
      selectedText = <TarifsSoftDev />;
      break;
    case 12:
      selectedText = <TarifsWebDev />;
      break;
    default:
      selectedText = <TarifsDefault />;
      break;
  }

  const mainColor = UseTarifsMainColor((state) => state.color);
  const secondColor = UseTarifsSecondColor((state) => state.color);
  const ribbonColor = UseTarifRibbonColor((state) => state.color);
  return (
    <div className="tarifs-details-texts">
      <motion.div
        className="tarifs-details-texts-ribbon"
        animate={{
          background: ribbonColor,
        }}
        transition={{ duration: 0.5 }}
      ></motion.div>
      <div
        className="tarifs-details-texts-vignette"
        style={{
          boxShadow: "inset 0 0 200px rgba(0, 0, 0, 0.12)",
        }}
      ></div>
      <motion.div
        className="tarifs-details-texts-background"
        animate={{
          background: mainColor,
          color: secondColor,
        }}
        transition={{ duration: 0.5 }}
      >
        {selectedText}
      </motion.div>
    </div>
  );
}
export default TarifsDetailsText;
